import { ComponentType, PropsWithChildren } from 'react';

import { Extension, attachComponentData } from '@backstage/core-plugin-api';

import {
  AdminV1AccountMode,
  WorkflowV1WorkflowInstanceInput,
} from '@spotify/confidence-graphql';

import { WORKFLOW_EXTENSION_KEY, WORKFLOW_EXTENSION_WRAPPER_KEY } from './keys';

type WorkflowCreateDialogProps = {
  open: boolean;
  onClose: () => void;
  overrides?: Partial<WorkflowV1WorkflowInstanceInput>;
  subtitle?: string;
};

export type WorkflowExtensionOptions = {
  name?: string;
  title: string;
  description?: string;
  workflowId: string;
  workflowPage: () => JSX.Element | null;
  workflowInstancePage: () => JSX.Element | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Extension point: concrete table row components accept different fragment types per workflow module, making a single shared props type impossible without a major generic refactor
  workflowTableRowComponent?: ComponentType<any>;
  workflowIcon: ComponentType<{ className?: string }>;
  createDialog?: ComponentType<WorkflowCreateDialogProps>;
  notCreatableInAccountModes?: AdminV1AccountMode[];
  openGraphComponent?: (name: string) => JSX.Element | null;
};

export type WorkflowExtensionComponent<_TReturnValue, _TInputProps> =
  () => null;

export function createWorkflowExtension<
  TReturnValue = unknown,
  TInputProps = unknown,
>(
  options: WorkflowExtensionOptions,
): Extension<WorkflowExtensionComponent<TReturnValue, TInputProps>> {
  return {
    expose() {
      const WorkflowExtensionDataHolder = () => null;

      attachComponentData(
        WorkflowExtensionDataHolder,
        WORKFLOW_EXTENSION_KEY,
        options,
      );

      return WorkflowExtensionDataHolder;
    },
  };
}

export const WorkflowExtensions: ComponentType<
  PropsWithChildren
> = (): JSX.Element | null => null;

attachComponentData(WorkflowExtensions, WORKFLOW_EXTENSION_WRAPPER_KEY, true);
